export default "__VITE_ASSET__77TIS84Q__"